import { Record } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { record_type, option_type, string_type, class_type, int32_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";

export class CustomStentReportViewModel extends Record {
    constructor(reportNumber, studyId, reportPath, reportDate) {
        super();
        this.reportNumber = (reportNumber | 0);
        this.studyId = studyId;
        this.reportPath = reportPath;
        this.reportDate = reportDate;
    }
}

export function CustomStentReportViewModel_$reflection() {
    return record_type("RAWMap.Models.View.CustomStentReport.CustomStentReportViewModel", [], CustomStentReportViewModel, () => [["reportNumber", int32_type], ["studyId", class_type("System.Guid")], ["reportPath", string_type], ["reportDate", option_type(class_type("System.DateTimeOffset"))]]);
}

export function CustomStentReportViewModel_getStudyId_Z76903C92(vm) {
    return vm.studyId;
}

export function CustomStentReportViewModel_getPrimaryId_Z76903C92(vm) {
    return vm.reportNumber;
}

export function CustomStentReportViewModel_get_primaryIdName() {
    return "ReportNumber";
}

export function CustomStentReportViewModel_get_description() {
    return "CustomStentReport";
}

export function CustomStentReportViewModel_desc_Z76903C92(_arg) {
    return CustomStentReportViewModel_get_description();
}

